import axios from "axios";
import { getToken } from "./auth";

import { API_URL } from './config';
const withAuth = () => ({
  headers: { Authorization: `Bearer ${getToken()}` },
  withCredentials: true,
});

export const getUsers = async (params = {}) =>
  (await axios.get(`${API_URL}/user`, { ...withAuth(), params })).data;

export const getUserById = async (id) =>
  (await axios.get(`${API_URL}/user/${id}`, withAuth())).data;

export const createUser = async (data) =>
    (await axios.post(`${API_URL}/user`, data, withAuth())).data;

export const updateUser = async (id, data) =>
    (await axios.patch(`${API_URL}/user/${id}`, data, withAuth())).data;

export const updateUserRoles = async (id, roles) =>
    (await axios.put(`${API_URL}/user/${id}/roles`, { roles }, withAuth())).data;

export const deleteUser = async (id) =>
    (await axios.delete(`${API_URL}/user/${id}`, withAuth())).data;

export const getMyPreferences = async () =>
  (await axios.get(`${API_URL}/user/me/preferences`, withAuth())).data;

export const updateMyPreferences = async (preferences = {}) =>
  (await axios.put(`${API_URL}/user/me/preferences`, preferences, withAuth())).data;
